import _ from 'lodash'

const valid = (field) => {
  if (_.isEmpty(field) || typeof field !== 'object') {
    return true
  } else if ('valid' in field) {
    return field.valid
  } else {
    return Array.isArray(field) ?
      field.every(subfield => valid(subfield)) :
      Object.keys(field).every(subfield => valid(field[subfield]))
  }
}

const allFieldsValid = (fields) => {
  return Object.keys(fields).every(field => valid(fields[field]))
}

export default allFieldsValid